import { css } from "@emotion/css";
import { space, themeTokens } from "@octopusdeploy/design-system-tokens";
type NameSummaryWithSlugProps = {
    name: string;
    slug?: string | null;
};
export function NameSummaryWithSlug({ name, slug }: NameSummaryWithSlugProps) {
    return (<>
            <span className={nameSummaryStyles}>{name}</span>
            {slug && <span className={slugSummaryStyles}>{slug}</span>}
        </>);
}
const nameSummaryStyles = css({
    marginRight: space[8],
});
const slugSummaryStyles = css({
    marginRight: space[8],
    color: themeTokens.color.text.secondary,
});
